import { IDropdownItem, ISelectOption, TTranslator } from '@smartshell/ui-kit';

import { ETaxVariant } from 'cashbox';
import { TLocalesKeys } from 'localization';
import { EPaymentItemType } from 'types';

import s from './Cashbox.module.scss';

const getEntityOptions = (
  t: TTranslator<TLocalesKeys>
): Array<IDropdownItem<EPaymentItemType>> => [
  { value: EPaymentItemType.TARIFF, title: t('taxes.entity.tariffs') },
  { value: EPaymentItemType.GOOD, title: t('taxes.entity.goods') },
  { value: EPaymentItemType.SERVICE, title: t('taxes.entity.services') },
  { value: EPaymentItemType.DEPOSIT, title: t('taxes.entity.deposit') },
];

const getTaxVariantOptions = (
  t: TTranslator<TLocalesKeys>
): Array<IDropdownItem<ETaxVariant>> => [
  { value: ETaxVariant.SIMPLE_INCOME, title: t('tax.option.simpleIncome') },
  {
    value: ETaxVariant.SIMPLE_INCOME_EXPENSES,
    title: t('tax.option.simpleIncomeExpenses'),
  },
  { value: ETaxVariant.MAIN, title: t('tax.option.main') },
  { value: ETaxVariant.PATENT, title: t('tax.option.patent') },
];

const renderKKMOption = (item: ISelectOption): JSX.Element => {
  return (
    <div className={s.kkm}>
      <span className={s.name}>{item.title}</span>
      <span className={s.inn}>{item.value}</span>
    </div>
  );
};

export { getEntityOptions, getTaxVariantOptions, renderKKMOption };
